import { render } from "./CrossSellResultsFTT.vue?vue&type=template&id=56f734aa&scoped=true"
import script from "./CrossSellResultsFTT.vue?vue&type=script&lang=js"
export * from "./CrossSellResultsFTT.vue?vue&type=script&lang=js"

import "./CrossSellResultsFTT.vue?vue&type=style&index=0&id=56f734aa&lang=scss"
import "./CrossSellResultsFTT.vue?vue&type=style&index=1&id=56f734aa&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4153154969/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f734aa"]])

export default __exports__